export default "__VITE_ASSET__BDLp63qZ__"